import { getUserConfiguration } from 'owa-session-store';
import isActionConfirmationsEnabled from './isActionConfirmationsEnabled';

export default function isAppNotificationsOptionDirty() {
    const userOptions = getUserConfiguration().UserOptions;
    const actionConfirmationsEnabledInUserOptions = userOptions.ShowNotificationBar;

    return actionConfirmationsEnabledInUserOptions !== isActionConfirmationsEnabled();
}
